const messages = {
  title: "Listini prezzi e brochure prodotto",
  description:
    "Scarica qui le brochure, i volantini e i listini prezzi più recenti dei nostri pneumatici Bridgestone e Firestone per auto, SUV e furgoni.",
  brochureCategories: {
    products: "Prodotti",
    brand_and_solutions: "Marchio e soluzioni",
    season_and_promotions: "Stagione e promozioni",
    format: "Formato",
    cars_and_vans: "Auto e veicoli commerciali",
    summer: "Estate",
    winter: "Inverno",
    promotions: "Promozioni",
    all_season: "Quattro stagioni",
    truck_and_buses: "Camion e autobus",
    motorcycle: "Motocicletta",
    agriculture: "Agricoltura",
    construction_machinery: "Macchine da costruzione",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiali",
    brochures: "Brochure",
    price_list: "Listino prezzi",
    materials: "Materiali",
    video_in_store: "Video con sottotitoli",
    video_online: "Video senza sottotitoli",
    banner_website: "Banner",
    banner_social_media: "Social media",
    logos: "Loghi",
  },
  searchMedia: "Inserisci una parola chiave",
  searchResults: "Risultati di ricerca",
};

export default {
  messages,
};
